import { TRIGGER_TOAST_ON, TRIGGER_TOAST_OFF } from './constants';

const initialState = {
    // data for toast that is shown for any error or success message
    toastMessage: '',
    toastType: 'success', //other values => error, warning, info
    toastAutoHideDuration: 3000,
    toastAnchorOrigin: { vertical: 'bottom', horizontal: 'right' },
    showToast: false,
};

export default function(state = initialState, action) {
    switch (action.type) {
        case TRIGGER_TOAST_ON: {
            const {
                toastMessage,
                toastType,
                toastAutoHideDuration,
                toastAnchorOrigin,
            } = action;
            return {
                ...state,
                toastMessage: toastMessage || state.toastMessage,
                toastType: toastType || state.toastType,
                toastAutoHideDuration:
                    toastAutoHideDuration || state.toastAutoHideDuration,
                toastAnchorOrigin: toastAnchorOrigin || state.toastAnchorOrigin,
                showToast: true,
            };
        }
        case TRIGGER_TOAST_OFF: {
            return {
                ...state,
                showToast: false,
            };
        }
        default:
            return state;
    }
}
